import React from "react";
import SimpleButtonLink from "./simpleButtonLink";
import { useMediaQuery } from "react-responsive";

const MediaMentions = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  return (
    <div id="partnerCta" className="full-width" style={content?.background ? { background: content?.background } : {}}>
      <div className="centralContainer">
        <div className={`partnerCta desktop_${content.desktopTextAlignment} mobile_${content.mobileTextAlignment}`}>
          <div
            className="title"
            dangerouslySetInnerHTML={{ __html: isMobile ? content?.mobileTitle : content?.title }}
          />
          <div className="text" dangerouslySetInnerHTML={{ __html: isMobile ? content?.mobileText : content?.text }} />
          <SimpleButtonLink {...content} linkClass="" />
        </div>
      </div>
    </div>
  );
};

export default MediaMentions;
